import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';
import router from '../../../../router/index';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    categories: [],
    category: {},
    message: {},
}

const getters = {
    getAllCategories(state){
        return state.categories;
    },
    getCategory(state){
        return state.category;
    },
    getCategoryName(){
        return state.category.name;
    },
    getCategoryTranslations(){
        return state.category.translations;
    },
    updateCategoryResponseMsg(state){
        return state.message;
    },
}

const mutations = {
    updateAllCategories(state, categories) {
        state.categories = categories
     },
     updateCategory(state, category) {
        state.category = category
     },
     updateCategoryResponseMsg(state, message) {
        state.message = message
     },
}

const actions = {
    ['LOAD_ALL_CATEGORIES']: ({commit}) => {
        return new Promise((resolve) => { 
        axios.get('category?orderBy=position',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllCategories', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

      ['GET_CATEGORY']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.get(`category/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateCategory', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['CREATE_CATEGORY']: ({commit}, formData) => {
        return new Promise((resolve) => { 
        axios.post(`category`, formData )
        .then(resp => {
            if(!resp.data.error){
                commit('updateCategoryResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            router.push(`/${i18n.locale}/categories`);
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
            .catch(error => {
                console.log(error)
                alert(i18n.tc(`skuTaken`))
                // this.$router.go(router.currentRoute)
                return;
            });
        })
      },

      ['EDIT_CATEGORY']: ({commit}, formData) => {
        return new Promise((resolve) => { 
        axios.put(`category/${formData.categoryId}`, formData )
        .then(resp => {
            if(!resp.data.error){
                commit('updateCategoryResponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_CATEGORY']: ({commit}, id) => {
        return new Promise((resolve) => { 
        axios.delete(`category/${id}`, 
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateCategoryResponseMsg', resp.data.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}